<template>
    <div class="vm-nav-menu-client flex-box flex-a-center flex-direction-row-reverse" v-click-outside="close_menu">
        <div class="flex-box">
            <i class="afd afd-scan fs24 lh1 mr24" @click="jump_scan"></i>
            <i class="afd afd-menu fs24 lh1" @click="tab_menu"></i>
        </div>
        <div class="menu-layer" v-if="is_show_menu" @click.self="close_menu">
            <div class="menu-inner-box pl16 pr16">
                <div class="type-1">
                    <span class="link-1 gl-hover-text" @click="jump($userlink(session_user).path)">{{$t('c.NavMenuClient.text1')}}</span>
                </div>
                <div class="type-2">
                    <span class="link-2 gl-hover-text" @click="jump('/setting/account')">{{$t('c.NavMenuClient.text2')}}</span>
                    <span class="link-2 gl-hover-text" @click="jump('/dashboard/order')">{{$t('c.NavMenuClient.text3')}}</span>
                    <span class="link-2 gl-hover-text" @click="jump('/dashboard/mark')">{{$t('c.NavMenuClient.text4')}}</span>
                    <span class="link-2 gl-hover-text" @click="jump_download_audio">{{$t('c.NavMenuClient.text5')}}</span>
                    <div class="mt10 mb10 line"></div>
                    <span class="link-2 gl-hover-text" @click="jump('/message/27f7cea2370d11e8ae8852540025c377')">{{$t('c.NavMenuClient.text6')}}</span>
                    <span class="link-2 gl-hover-text" @click="jump('/dashboard/dev')">{{$t('c.NavMenuClient.text7')}}</span>
                    <span class="link-2 gl-hover-text" @click="jump('/album/248b4bb2c9b111e9a9bb52540025c377/92aa33b68b4a11e8aa6952540025c377')">{{$t('c.NavMenuClient.text8')}}</span>
                    <span class="link-2 gl-hover-text" @click="call_share">{{$t('c.NavMenuClient.text9')}}</span>
                    <span class="link-2 gl-hover-text" @click="open_lang">{{$t('c.NavMenuMobile.text12')}}</span>  

                    <div class="mt10 mb10 line"></div>
                    <span class="link-2 gl-hover-text" @click="logout">{{$t('c.NavMenuClient.text10')}}</span>
                    <span class="link-2 black-3 fs14">{{$t('c.NavMenuClient.text11')}} {{GL.ENV.afd_version}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: 'nav-menu-client',
    inject:['app_action_sheet'],
    props: {
        is_icon_avatar: {
            default: true
        },
    },
    components:{
    },
    data() {
        return {
            is_show_menu: false,
        }
    },
    watch:{
        is_show_menu(v) {
            if(v){
                this.mixin_lock_scroll();
            }else{
                this.mixin_unlock_scroll();
            }
        },
    },
    computed: {
        ...mapState("app", [
            "session_user",
            "auth_token",
        ]),
        is_creator() {
            if (
                this.session_user &&
                this.session_user.creator &&
                this.session_user.creator.status
            ) {
                return true;
            }
            return false;
        },
        share_config() {
            return {
                url: 'https://afdian.net/app',
                source: `${location.origin}`,
                title: `下载爱发电 App | 爱发电`,
                description: `将创作的自由还给创作者！爱发电是让创作者简单地获得稳定收入的粉丝赞助平台。无论你在创作什么，都能在这里获得持续的资金支持，让创作从此更自由。`
            };
        },
    },
    mounted() {
    },
    methods: {
        call_share(){
            this.$bridge.call("share", this.share_config, () => {});
            this.close_menu();
        },
        tab_menu() {
            this.is_show_menu = !this.is_show_menu;
        },
        close_menu() {
            this.is_show_menu = false;
        },
        jump(path){
            this.close_menu();
            this.$mixin_router_push(path)
        },
        jump_download_audio(){
            this.$bridge.call("download_music", { }, data => {});
        },
        jump_scan(){
            this.$bridge.call("scan", { }, data => {});
        },
        logout(){
            this.$bridge.call("logout", { }, data => {
                console.log(data)
            });
        },
        // open_menu() {
        //     this.$bus.$emit("SESSION_EXPIRED");
        //     this.$router.push({ name: "login" });
        //     this.close_menu();
        // },
        open_lang(){
          this.app_action_sheet('open', {
            component:'action-lang',
          })
          this.close_menu();
        }
    }
};
</script>

<style lang="stylus" scoped>
.vm-nav-menu-client {
    height: $nav-mobile-height;
    padding: 0 px2rem(16);
    .menu-layer{
        height:$nav-mobile-height-other;
        position:fixed;
        width:100%;
        box-sizing: border-box;
        top:$nav-mobile-height;
        left:0;
        z-index 100;
        background: $black-3;
        .menu-inner-box{
            background: $white;
        }
        .type-1 {
            border-bottom: 1px solid $black-1;

            .link-1 {
                color: $purple;
                padding: 20px 0;
                display: block;
            }
        }

        .type-2 {
            padding: 10px 0;

            .link-2 {
                padding: 10px 0;
                display: block;
                color: $black-8;
                cursor: pointer;
            }
        }
    }
  @media (max-height: $small-device-height) {
    font-size:14px;
    .menu-layer{
      .type-1 {
          .link-1 {
              padding: 8px 0;
          }
      }
      .type-2 {
          padding: 8px 0;
          .link-2 {
              padding: 8px 0;
          }
      }
    }
  }
  @media (max-height: $tiny-device-height) {
    font-size:12px;
    .menu-layer{
      .type-1 {
          .link-1 {
              padding: 4px 0;
          }
      }
      .type-2 {
          padding: 4px 0;
          .link-2 {
              padding: 4px 0;
          }
      }
    }
  }
}
</style>
